module.exports = __webpack_public_path__ + "static/media/taskCanceled.4b5dc250.svg";